import { ref } from 'vue'
import { useAuthStore } from '~/stores/useAuthStore'
import { useGameStore } from '~/stores/useGameStore'

/** État partagé — layout + objectifs progression. */
const showOfflineReportModal = ref(false)

export function useOfflineReportModal() {
  const auth = useAuthStore()
  const game = useGameStore()

  async function openOfflineReportModal() {
    if (auth.isAuthenticated && game.offlineStatus === 'loading') {
      await auth.hydrateOfflineReportInBackground()
    }
    showOfflineReportModal.value = true
  }

  function closeOfflineReportModal() {
    showOfflineReportModal.value = false
  }

  return {
    showOfflineReportModal,
    openOfflineReportModal,
    closeOfflineReportModal,
  }
}
